import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-access-quote-pc.component.scss';
var FormItemAccessQuotePc = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemAccessQuotePc, _super);
    function FormItemAccessQuotePc(element) {
        return _super.call(this, element) || this;
    }
    FormItemAccessQuotePc.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now-pc__button"));
    };
    FormItemAccessQuotePc.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemAccessQuotePc.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var declined = form.querySelector(".form__declined--container");
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var value = form.querySelector(".output-value");
        var name = form.querySelector(".form__success-container__firstname");
        var qualifiedAmount = form.querySelector(".form__success-container__approvedamount");
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var description = form.querySelector("input[name=description]");
        var firstName = form.querySelector("input[name=first-name]");
        var lastName = form.querySelector("input[name=last-name]");
        var contact = form.querySelector("input[name=phone-number]");
        var contact2 = form.querySelector("input[name=phone-number-2]");
        var gross = form.querySelector("input[name=gross]");
        var monthlyexpenses = form.querySelector("input[name=monthlyexpenses]");
        var idNum = form.querySelector("input[name=identification]");
        var email = form.querySelector("input[name=email]");
        var date = form.querySelector("input[name=date]");
        var time = form.querySelector("select[name=time]");
        var _dateTime = "anytime";
        if (date && time) {
            if (time.value !== "Anytime") {
                _dateTime += date.value + " " + time.value;
            }
        }
        var _postData = {
            'description': (description ? description.value : ""),
            'firstName': (firstName ? firstName.value : ""),
            'lastName': (lastName ? lastName.value : ""),
            'contact': (contact ? contact.value : ""),
            'contact2': (contact2 ? contact2.value : ""),
            'gross': (gross ? gross.value : ""),
            'monthlyexpenses': (monthlyexpenses ? monthlyexpenses.value : ""),
            'idNum': (idNum ? idNum.value : ""),
            'email': (email ? email.value : ""),
            'timeToCall': _dateTime,
            'source': this.formsService.isMobile()
        };
        var url = this.baseUrl + "/services/SubmitApplicationFormPC.jsp";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
            var data = pResponse.data;
            // service ok
            loader.classList.remove("active");
            if (!data.error && (data.amount || data.code)) {
                if (data.amount) {
                    _this.analyticsService.dtmFormComplete("complete", data.leadID);
                    thankYou.classList.add("active");
                    declined.classList.remove("active");
                    error.classList.remove("active");
                    success.classList.add("active");
                    name.innerHTML = firstName.value;
                    value.innerHTML = "R" + data.amount;
                    qualifiedAmount.innerHTML = data.amount;
                }
                else {
                    _this.analyticsService.dtmFormComplete("complete", data.code);
                    var _tmp = _this.formsService.powerCurveErrors.find(function (item) {
                        return item.code = data.code;
                    });
                    if (_tmp) {
                        _this.analyticsService.dtmRecordSiteError(_tmp.message);
                    }
                    else {
                        _this.analyticsService.dtmRecordSiteError("Access Quote Declined");
                    }
                    thankYou.classList.add("active");
                    success.classList.remove("active");
                    error.classList.remove("active");
                    declined.classList.add("active");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                thankYou.classList.add("active");
                success.classList.remove("active");
                declined.classList.remove("active");
                error.classList.add("active");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemAccessQuotePc;
}(Base));
export { FormItemAccessQuotePc };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-access-quote-pc/form-item-access-quote-pc.component.ts
// module id = 823
// module chunks = 0